import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Button, Text, Page } from '../../../..'

import panelStyles from '../../../Panel/Panel.module.scss'
import styles from './ShowNoChangeConfirmPanel.module.scss'

const propTypes = {
  handleClickBack: PropTypes.func,
}

const ShowNoChangeConfirmPanel = ({ handleClickBack }) => (
  <Page>
    <Page.Body className={styles.body}>
      <div className={panelStyles.container}>
        <div className={styles.noChangeText}>
          <Text
            size='m'
            align='center'
            variant='neutralCool'
            variantCount='900'
            className={styles.confirmText}
          >
            <FormattedMessage
              id='Homeowner.interest.paidExtra.confirmNoChangeDescription'
              defaultMessage="We successfully saved your loan balance. Come back and update it again when you've put additional money towards principal!"
            />
          </Text>
        </div>
        <div className={panelStyles.submitWrap}>
          <Button fullWidth onClick={handleClickBack}>
            <FormattedMessage
              id='Homeowner.interest.paidExtra.returnButton'
              defaultMessage='Return to dashboard'
            />
          </Button>
        </div>
      </div>
    </Page.Body>
  </Page>
)

ShowNoChangeConfirmPanel.propTypes = propTypes

export default ShowNoChangeConfirmPanel
